import { InjectionToken } from '@angular/core';

export const PUBKEY_TOKEN = new InjectionToken<string>('Rave.PubKey');
